/**
 * Should be refactored without jQuery. Can be included in the Contests/Leaderboard component, if we include this functionality in that component.
 */

if (document.readyState === 'complete') {
  // The page is already loaded before this script runs, which means turbo:load won't trigger on this page load. Trigger it manually.
  loaded();
}
document.addEventListener('turbo:load', function () {
  // This event will be fired every time a page is loaded (after the file is included in the document).
  loaded();
});

function loaded() {
  /**
   * Delete challenge
   */
  $('#delete-challenge').on('submit', function (e) {
    e.preventDefault();

    const ok = confirm(
      'Are you sure you want to delete this challenge? This action cannot be undone.'
    );
    if (ok) {
      this.submit();
    }
  });
}
